interface SelectedFilterLabelParams {
  filterDatasetId: string;
  masterDatasetId?: string;
  caption?: string;
  itemLabel: string;
}

export const getSelectedFilterLabel = ({
  filterDatasetId,
  masterDatasetId,
  caption,
  itemLabel,
}: SelectedFilterLabelParams): string => {
  if (filterDatasetId === masterDatasetId || !caption) {
    return itemLabel;
  }

  return `${caption}: ${itemLabel}`;
};
